import {HttpServices} from "../Helpers";

export const GetAllCandidatesSearchDBNewV2 = async ({
  use_for = "search_db",
  limit = 12,
  page = 1,
  params,
  arrays = {},
  search,
  isDropdown,
}) => {
  let queryString = "";
  Object.keys(arrays).forEach((key) => {
    if (arrays[key])
      arrays[key].forEach((value) => {
        queryString = `${queryString}&${key}=${value}`;
      });
  });

  return await HttpServices.post(
    `${process.env.REACT_APP_ANALYTICS_SDB_API}/dynamic-analytics/candidate/index`,
    {
      ...params,
      use_for,
      page,
      limit,
      ...arrays,
      ...(isDropdown && search && {query: [search]}),
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
};
